import { jsx as t } from "react/jsx-runtime";
import { Tooltip as o } from "@mui/joy";
import { Stack as i } from "@mui/material";
const r = { "& > button, & > div, & > li, & > a, & > span, & p": { pointerEvents: "none", opacity: 0.5, cursor: "not-allowed" } }, n = ({ children: n2, tooltip: e }) => t(o, { title: e || "Редагування інформації закритих періодів заборонено", sx: { maxWidth: "250px", pointerEvents: "none" }, children: t(i, { sx: r, children: n2 }) });
export {
  n as ModificationDenyTooltip
};
//# sourceMappingURL=ModificationDenyTooltip.js.map
